var naturesGer = {
    "100": "Robust",      // Hardy
    "101": "Solo",        // Lonely
    "102": "Brave",       // Brave
    "103": "Hart",        // Adamant
    "104": "Frech",       // Naughty
    "105": "Kühn",        // Bold
    "106": "Sanft",       // Docile
    "107": "Locker",      // Relaxed
    "108": "Pfiffig",     // Impish
    "109": "Lasch",       // Lax
    "110": "Scheu",       // Timid
    "111": "Hastig",      // Hasty
    "112": "Ernst",       // Serious
    "113": "Froh",        // Jolly
    "114": "Naiv",        // Naive
    "115": "Mäßig",       // Modest
    "116": "Mild",        // Mild
    "117": "Ruhig",       // Quiet
    "118": "Zaghaft",     // Bashful
    "119": "Hitzig",      // Rash
    "120": "Still",       // Calm
    "121": "Zart",        // Gentle
    "122": "Sacht",       // Sassy
    "123": "Vorsichtig",  // Careful
    "124": "Kauzig"       // Quirky
};
export default naturesGer;